/**
 * Skeleton della Dashboard: blocchi grigi animati che ricalcano la struttura
 * (header tema, numeri importanti, sezione obiettivi, sezione momenti).
 */
export default function DashboardSkeleton() {
  return (
    <div className="min-h-screen bg-canvas text-ink" data-testid="dashboard-skeleton">
      {/* Top bar finta */}
      <div className="border-b border-line">
        <div className="max-w-[1600px] mx-auto px-6 py-5 flex items-center justify-between">
          <div className="space-y-2">
            <div className="h-3 w-24 bg-line animate-pulse rounded" />
            <div className="h-6 w-72 bg-line animate-pulse rounded" />
          </div>
          <div className="flex gap-2">
            <div className="h-8 w-24 bg-line animate-pulse rounded" />
            <div className="h-8 w-24 bg-line animate-pulse rounded" />
          </div>
        </div>
      </div>

      <div className="max-w-[1600px] mx-auto px-6 py-8 space-y-10">
        {/* Numeri importanti */}
        <section>
          <div className="h-3 w-32 bg-line animate-pulse rounded mb-4" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line">
            {[0, 1, 2].map((i) => (
              <div key={i} className="bg-paper p-6 space-y-3">
                <div className="h-3 w-24 bg-line animate-pulse rounded" />
                <div className="h-10 w-3/4 bg-line animate-pulse rounded" />
                <div className="h-2 w-full bg-line animate-pulse rounded" />
              </div>
            ))}
          </div>
        </section>

        {/* Obiettivi */}
        <section>
          <div className="h-3 w-32 bg-line animate-pulse rounded mb-4" />
          <div className="space-y-3">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="border border-line bg-paper p-5 flex items-center gap-4">
                <div className="h-3 w-3 bg-line animate-pulse rounded-full" />
                <div className="flex-1 space-y-2">
                  <div className="h-4 w-2/3 bg-line animate-pulse rounded" />
                  <div className="h-3 w-1/2 bg-line animate-pulse rounded" />
                </div>
                <div className="h-8 w-16 bg-line animate-pulse rounded" />
              </div>
            ))}
          </div>
        </section>

        {/* Momenti CTA */}
        <section>
          <div className="h-3 w-32 bg-line animate-pulse rounded mb-4" />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-line border border-line">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="bg-paper p-6 space-y-3">
                <div className="h-3 w-8 bg-line animate-pulse rounded" />
                <div className="h-5 w-3/4 bg-line animate-pulse rounded" />
                <div className="h-3 w-full bg-line animate-pulse rounded" />
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
